import {Dispatch, SetStateAction} from 'react';
import InputField from '../../../../../../../components/simpleInput';
import {StoreOrderSteps} from '../../../../../../../services/hookService/getOrderDetails/helper';
import {
  DeliveryMethodValue,
  deliveryOptions,
} from '../../../../../../../services/hookService/postBasket/deliveryOptions';
import ReceiptImageUpload from '../../../../../../shopping-basket/cash-payment/card-to-card-pay/ReceiptImageUpload';
import InfoRow from '../../../../../../shopping-basket/ItemCard/InfoRow';
import RadioGroupList from './RadioGroupList';

interface Props {
  isDeliveryInPerson: boolean;
  orderStoreStep: StoreOrderSteps;
  deliveryDate?: string;
  acceptDate: string | null;
  supplierProvideAt: string | null;
  receiptImage?: string;
  uploadedImage: File | null;
  deliveryOption: DeliveryMethodValue;
  trackingCode: string;
  setUploadedImage: Dispatch<SetStateAction<File | null>>;
  setDeliveryOption: Dispatch<SetStateAction<DeliveryMethodValue>>;
  setTrackingCode: Dispatch<SetStateAction<string>>;
}

const MyStoreOrderSupplyingStatus = ({
  isDeliveryInPerson,
  orderStoreStep,
  deliveryDate,
  acceptDate,
  receiptImage,
  uploadedImage,
  deliveryOption,
  trackingCode,
  setUploadedImage,
  setDeliveryOption,
  setTrackingCode,
  supplierProvideAt,
}: Props) => {
  const isOrderItemProcessing = orderStoreStep === StoreOrderSteps.PROCESSING;

  const isOrderItemCompleted =
    orderStoreStep === StoreOrderSteps.COMPLETED ||
    orderStoreStep === StoreOrderSteps.STORE_DELIVERED ||
    orderStoreStep === StoreOrderSteps.USER_DELIVERED ||
    orderStoreStep === StoreOrderSteps.SHIPPED;

  const OrderStatusStep = (orderStoreStep: StoreOrderSteps): string => {
    switch (true) {
      case orderStoreStep === StoreOrderSteps.PAYMENT_RECEIVED:
        return 'در انتظار تایید';

      case isOrderItemProcessing:
        return 'در حال تامین';

      case isOrderItemCompleted:
        if (isDeliveryInPerson) {
          return 'تحویل شده';
        } else {
          return 'تامین شده';
        }
      default:
        return 'مشخص نشده';
    }
  };

  if (orderStoreStep === StoreOrderSteps.PAYMENT_RECEIVED)
    return (
      <div className="space-y-2">
        <span className="text-sm font-medium text-zinc-500">
          مراحل تامین سفارش
        </span>
        <div className="p-3 space-y-3 bg-zinc-100 rounded-xl">
          <InfoRow
            icon="icon-namereport1"
            label="وضعیت سفارش"
            value={OrderStatusStep(orderStoreStep)}
          />
        </div>
      </div>
    );

  if (isOrderItemProcessing)
    return (
      <div className="space-y-2">
        <span className="font-medium text-zinc-500 text-md">
          مراحل تامین سفارش
        </span>
        <div className="p-3 space-y-2.5 bg-zinc-100 rounded-xl">
          <InfoRow
            icon="icon-namereport1"
            label="وضعیت سفارش"
            value={OrderStatusStep(orderStoreStep)}
          />
          {Boolean(acceptDate) && (
            <InfoRow
              icon="icon-nameCalendar"
              label="تاریخ تایید سفارش"
              value={acceptDate ?? 'مشخص نشده'}
            />
          )}
          {Boolean(supplierProvideAt) && (
            <InfoRow
              icon="icon-nameCalendar"
              label="تاریخ تامین کالاها"
              value={supplierProvideAt ?? 'مشخص نشده'}
            />
          )}
          {!isDeliveryInPerson && (
            <>
              <RadioGroupList
                title="نوع ارسال"
                required
                value={deliveryOption}
                setValue={setDeliveryOption}
                options={deliveryOptions}
              />

              <ReceiptImageUpload
                title="بارگذاری تصویر فیش ارسال "
                setUploadedImage={setUploadedImage}
                uploadedImage={uploadedImage}
              />

              <div className="flex justify-between w-full ">
                <InputField
                  label="کد رهگیری مرسوله "
                  labelClassName=" text-sm pr-1"
                  className="bg-zinc-100"
                  name="trackingCode"
                  placeholder="کد رهگیری مرسوله را وارد کنید"
                  type="string"
                  required
                  value={trackingCode ?? ''}
                  onValueChange={(value: string) => setTrackingCode(value)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    );

  return (
    <div className="space-y-1">
      <span className="font-medium text-zinc-500 text-md">
        مراحل تامین سفارش
      </span>
      <div className="p-3 space-y-3 bg-zinc-100 rounded-xl">
        <InfoRow
          icon="icon-namereport1"
          label="وضعیت سفارش"
          value={OrderStatusStep(orderStoreStep)}
        />
        {isOrderItemCompleted && (
          <>
            <>
              {!isDeliveryInPerson ? (
                <>
                  {Boolean(acceptDate) && (
                    <InfoRow
                      icon="icon-nameCalendar"
                      label="تاریخ تایید سفارش"
                      value={acceptDate ?? 'مشخص نشده'}
                    />
                  )}

                  {Boolean(deliveryDate) && (
                    <>
                      <InfoRow
                        icon="icon-nameCalendar"
                        label="تاریخ ارسال"
                        value={deliveryDate ?? 'مشخص نشده'}
                      />

                      <div className="my-2" />

                      <span className="mt-2 text-sm font-medium text-gray-700">
                        تصویر فیش ارسال
                      </span>

                      <a
                        href={receiptImage}
                        target={'_blank'}
                        download="image.jpg"
                        className="block mt-2 "
                      >
                        <img
                          src={receiptImage}
                          alt="receipt preview"
                          className="flex items-center justify-center no-underline bg-white border border-gray-600 rounded-lg size-12"
                        />
                      </a>
                    </>
                  )}
                </>
              ) : (
                Boolean(supplierProvideAt) && (
                  <InfoRow
                    icon="icon-nameCalendar"
                    label="تاریخ تامین کالاها"
                    value={supplierProvideAt ?? 'مشخص نشده'}
                  />
                )
              )}
            </>
          </>
        )}
      </div>
    </div>
  );
};

export default MyStoreOrderSupplyingStatus;
